// extracted by mini-css-extract-plugin
export var icon = "TableResults-module--icon--kfrj5";
export var toggle = "TableResults-module--toggle--hAJ3K";